import { AbstractControl } from "@angular/forms";

export enum FormError {
  // General
  REQUIRED = "required",

  // Checkbox
  REQUIRED_ITEMS = "requiredItems",

  // Array
  INVALID_FORM_ARRAY = "invalidFormArray",
}

/*
 * Remove specific errors on child controls without touching possible other errors
 * @see https://github.com/angular/angular/issues/21564
 *
 * It also removes an empty error object, because this will be also evaluated as "invalid"
 */
export function deleteSpecificFormError(
  formControl: AbstractControl,
  errorName: FormError,
) {
  if (!formControl.errors) {
    return;
  }

  if (formControl.hasError(errorName)) {
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete -- Angular requires removing the property completely to reset a form error. Setting it to 'null' is insufficient.
    delete formControl.errors[errorName];
  }

  if (isObjectEmpty(formControl.errors)) {
    formControl.setErrors(null);
  }
}

function isObjectEmpty(object: Record<PropertyKey, unknown>) {
  return Object.keys(object).every(
    (key) =>
      object[key] === "" || object[key] === null || object[key] === undefined,
  );
}
